import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Grid, TextField, Container, Button, Typography, Card } from '@material-ui/core';

const PassResend = () => {
    const [epos, setEpos] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [foundEmail, setFoundEmail] = useState(false);


    useEffect(() => {
        //console.log(epos);

    }, [epos])

    function emailFieldChange(e) {
        if (showPopup === true) {
            setShowPopup(false);
        }
        setEpos(e.target.value)
    }

    function resendPass() {
        fetch('/passresend/' + epos).then(response => {
            setShowPopup(true);
            if (response.status === 200) {
                setFoundEmail(true);

            }
            else {
                setFoundEmail(false);
            }
                });
    }

    return (
        <Container center>
            <Card>
                <Grid container justify="center">
                    <Typography variant="h5">
                        Stuur wagwoord weer
            </Typography>
                </Grid>
                <Grid container justify="center">
                    <Grid item xs={6} sm={6} lg={6}>
                        <TextField onChange={emailFieldChange} id="epos" type="email" label="Epos adres" variant="outlined" margin="normal" fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                        <Grid container justify="center">

                            <Button
                                variant="contained"
                                component="label"
                                color="primary"
                                onClick={() => { resendPass() }}

                            >
                                Epos my wagwoord
            </Button>
                        </Grid>
                    </Grid>
                    {showPopup && foundEmail ? 
                        <Grid item xs={12} sm={12} lg={12}>
                            <Grid container justify="center">
                                Epos gestuur aan {epos}!
                            </Grid>
                        </Grid>

                        :
                        <Grid></Grid>

                    }
                    {showPopup && !foundEmail ? 
                        <Grid item xs={12} sm={12} lg={12}>
                            <Grid container justify="center">
                                Epos ({epos}) nie gevind nie!
                            </Grid>
                        </Grid>
                        :
                        <Grid></Grid>
                        
                        }
                    {/* 
                         <input id="epos" type="email" onChange={}></input>
                        <button onClick={() => { resendPass() }}>Resend Pass!</button>

             */}
                </Grid>
            </Card>
        </Container>

    )

}

export default PassResend;


// WEBPACK FOOTER //
// ./src/components/PassResend.js